import { Action } from "redux";
import * as SearchActions from "../actions/SearchActions";
import { TaskModel } from "../model/Search";

export function tasks(state: TaskModel[] = [], action: Action): TaskModel[] {
    switch (action.type) {
        case SearchActions.RECEIVE_TASKS: {
            const receiveAction = action as SearchActions.ReceiveTasksAction;
            return receiveAction.taskData;
        }
        default:
            return state;
    }
}
